import { render, staticRenderFns } from "./LocalLoader.vue?vue&type=template&id=545c8c95"
import script from "./LocalLoader.vue?vue&type=script&lang=js"
export * from "./LocalLoader.vue?vue&type=script&lang=js"
import style0 from "./LocalLoader.vue?vue&type=style&index=0&id=545c8c95&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('545c8c95')) {
      api.createRecord('545c8c95', component.options)
    } else {
      api.reload('545c8c95', component.options)
    }
    module.hot.accept("./LocalLoader.vue?vue&type=template&id=545c8c95", function () {
      api.rerender('545c8c95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/common/LocalLoader.vue"
export default component.exports